import script from "./UpdateOrderPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateOrderPopup.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__